import React, { useMemo, useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, Col, Collapse, Navbar, NavbarToggler } from 'reactstrap';
import BellIcon from 'react-bell-icon';
import { getOverview } from '../../actions/Home';
import { disableDeleteMode, enableDeleteMode, logout, toggleCollapse } from '../../actions/User';
import { ReactComponent as EpikLogoSvg } from '../../Res/granite-logo.svg';
import Navigation from '../Navigation';
import '../Navigation.css';
import AddSecurityCodeModal from '../AddSecurityCodeModal';
import {
  latestReleaseNote,
  getMaintenanceNotes,
  setMaintenanceNoteSeen,
} from '../../actions/EpikBoxes';
import Countdown from '../Countdown';
import Notification from './Notification';
import WebsiteNotificationBar from '../WebsiteNotificationBar';
import Crums from '../Crums';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const url = require('url');

const Header = ({
  user,
  logout,
  children,
  enableDeleteMode,
  disableDeleteMode,
  deleteMode,
  collapse,
  toggleCollapse,
  getOverview,
  securityCode,
  latestReleaseNote,
  getMaintenanceNotes,
  setMaintenanceNoteSeen,
}) => {
  const location = useLocation();

  const maintenanceUpdate = useSelector(store => store.AppState.boxDetails.maintenanceNotification);

  const [modalStatus, setModalStatus] = useState(false);
  const [bannerStatus, setBannerStatus] = useState(false);
  const [bannerText, setBannerText] = useState({ htmlText: '' });
  const [maintenanceBanners, setmaintenanceBanners] = useState([]);
  const [showMaintenanceBanners, setShowMaintenanceBanners] = useState(false);

  const token = localStorage.getItem('jwtToken') || null;

  useEffect(() => {
    setInterval(() => {
      if (!localStorage.getItem('jwtToken')) {
        window.location.reload();
      }
    }, 1000)
  }, [])

  const checkSecurityCode = () => {
    global.deleteMode = true;
    enableDeleteMode();
    setModalStatus(!modalStatus);
    getOverview(token);
  };

  useEffect(() => {
    if (maintenanceUpdate?.maintenanceAlert?.length > 0) {
      setBannerStatus(true);
      const priorityBanner = maintenanceUpdate?.maintenanceAlert?.filter(
        notify => notify.priority === 1,
      );
      setBannerText(priorityBanner[0].description);
      setmaintenanceBanners(maintenanceUpdate?.maintenanceAlert?.reverse());
    }
  }, [maintenanceUpdate]);

  useMemo(async () => {
    try {
      const { maintenanceAlert: releaseNotes } = await latestReleaseNote(token);
      if (releaseNotes?.length > 0) {
        const priorityBanner = releaseNotes.filter(notify => notify.priority === 1);
        setBannerText(priorityBanner[0].description);
        setmaintenanceBanners(releaseNotes?.reverse());
        setBannerStatus(true);
      }
    } catch (error) {
      // Handle the error here, e.g., log it or display a user-friendly message.
      console.error('Error fetching maintenance alert:', error.message);
    }
  }, []);
  const navStyle = {
    width: '100%',
    minWidth: 240,
    backgroundColor: '#fcfdff',
    top: bannerStatus ? 30 : 0,
  };
  const onLogoutPress = async () => {
    const token = localStorage.getItem('jwtToken');
    logout(token);
  };

  const displayNotifications = async () => {
    setShowMaintenanceBanners(!showMaintenanceBanners);
  };

  const getActiveNotificationsIds = async () => {
    return maintenanceBanners?.reduce((filteredIds, note) => {
      filteredIds.push(note?._id);
      return filteredIds;
    }, []);
  };

  const clearUserNotifications = async () => {
    const activeNotificationsIds = await getActiveNotificationsIds();
    const seen = await setMaintenanceNoteSeen(token, activeNotificationsIds);
    if (seen) {
      setmaintenanceBanners([]);
      setBannerStatus(false);
    }
  };

  return (
    <>
      <div style={{ position: 'fixed', top: 0, zIndex: 999, width: '100%', marginTop: 0 }}>
        <WebsiteNotificationBar isOpen={bannerStatus} toggle={() => setBannerStatus(false)}>
          {bannerText}
        </WebsiteNotificationBar>
        <Navbar style={navStyle} expand="sm">
          <Link to="/" className="navbar-brand">
            <Button
              color="link"
              onClick={() => {
                const urlObj = url.parse(document.location.href, true);
                if (user.role === 'superAdmin' && urlObj.pathname === '/') {
                  setModalStatus(!modalStatus);
                }
                if (user.role === 'superAdmin') {
                  getOverview(localStorage.getItem('jwtToken') || null);
                }
              }}
            >
              <EpikLogoSvg width={80} height={40} />
            </Button>
          </Link>
          {deleteMode && (
            <Col xs="auto">
              <Link to="/">
                <Button
                  outline
                  size="sm"
                  color="danger"
                  onClick={() => {
                    global.deleteMode = false;
                    disableDeleteMode();
                    getOverview(localStorage.getItem('jwtToken') || null);
                  }}
                >
                  EPIK Dev Mode
                </Button>
              </Link>
            </Col>
          )}
          <Button
            title="Your account has read only access"
            hidden={!user.readOnly}
            outline
            size="sm"
            color="danger"
          >
            Read Only Mode
          </Button>
          <Col xs="auto">
            <Countdown />
          </Col>
          <NavbarToggler
            className={collapse ? 'custom-toggler-close' : 'custom-toggler-hamburger'}
            onClick={() => toggleCollapse(!collapse)}
          />
          <Collapse isOpen={collapse} navbar>
            <Navigation mobile={collapse} user={user} onLogout={onLogoutPress} />
          </Collapse>

          {maintenanceBanners.length > 1 && (
            <div
              className="maintenance-banners"
              data-count={maintenanceBanners.length > 9 ? `9+` : maintenanceBanners.length}
              onClick={displayNotifications}
            >
              <BellIcon color="#3b59a9" width="20" active animate style={{ margin: '0 10px' }} />
              {showMaintenanceBanners && (
                <Notification
                  maintenanceBanners={maintenanceBanners}
                  clearUserNotifications={clearUserNotifications}
                />
              )}
            </div>
          )}
        </Navbar>
      </div>
      {location?.pathname === '/' ? null : (
        <div style={{ paddingTop: '4rem' }}>
          <Crums />
        </div>
      )}

      <div style={{ paddingTop: bannerStatus ? 30 : 0 }}>
        {children}
        <AddSecurityCodeModal
          isOpen={modalStatus}
          onCancel={() => {
            setModalStatus(!modalStatus);
          }}
          hiddenDelete
          onConfirm={checkSecurityCode}
          featureName={'hiddenDelete'}
        />
      </div>
    </>
  );
};

const mapStateToProps = store => ({
  user: store.AppState.user,
  deleteMode: store.AppState.deleteMode,
  collapse: store.UIState.toggleCollapse,
  securityCode: store.UIState.users.addedUser.security,
  latestRelease: store.AppState.boxDetails.latestRelease,
});

const mapDispatchToProps = dispatch => ({
  logout: token => dispatch(logout(token)),
  toggleCollapse: val => dispatch(toggleCollapse(val)),
  enableDeleteMode: () => dispatch(enableDeleteMode()),
  disableDeleteMode: () => dispatch(disableDeleteMode()),
  getOverview: token => dispatch(getOverview(token)),
  latestReleaseNote: token => dispatch(latestReleaseNote(token)),
  getMaintenanceNotes: token => dispatch(getMaintenanceNotes(token)),
  setMaintenanceNoteSeen: (token, activeNotificationsIds) =>
    dispatch(setMaintenanceNoteSeen(token, activeNotificationsIds)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Header);
